import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { dateAsString } from '../../shared/date.helper';
import { Inspection } from '../../shared/interfaces';
import { permissions } from '../../shared/permissions';
import { UserService } from '../../user/user.service';
import { InspectionAssignVendorComponent } from '../assign.vendor/assign.vendor.component';
import { InspectionService } from '../inspection.service';
import { InspectionStatus } from '../inspection.status';

@Component({
  selector: 'app-inspection-waiting',
  templateUrl: './inspection-waiting.component.html',
  styleUrls: ['./inspection-waiting.component.scss'],
})
export class InspectionWaitingComponent implements OnInit {
  inspections: Inspection[] = null;
  canEdit = false;
  count = 0;
  url = 'inspection';
  loading = true;
  canAdd = false;
  loadDebounced = new Subject();
  @ViewChild('assignVendorModal', { static: true }) public assignVendorModal: InspectionAssignVendorComponent;

  actions = {
    assignVendor: [
      {
        callback: (ev, inspection: Inspection) => async () => {
          return this.assignVendor(ev, inspection);
        },
      },
    ],
  };

  column = [
    { field: 'customerName', header: 'Customer', type: 'text', orderBy: 'customer.name' },
    { field: 'address', header: 'Location Address', type: 'text', orderBy: 'inspection.address' },
    { field: 'city', header: 'City', type: 'text', orderBy: 'inspection.city' },
    { field: 'state', header: 'State', type: 'text', orderBy: 'inspection.state' },
    { field: 'purpose', header: 'Purpose', type: 'text', orderBy: 'inspection.purpose' },
    { field: 'policyNumber', header: 'Policy No.', type: 'text', orderBy: 'policy.number' },
    { field: 'date', header: 'Due Date', type: 'date', orderBy: 'inspection.dueDate' },
    { field: 'daysSince', header: 'Days since added', type: 'text', orderBy: 'inspection.createdAt' },
    { field: 'notes', header: 'Notes', type: 'text', orderBy: 'inspection.notes' },
    {
      field: 'vendor.name',
      header: 'Vendor',
      type: 'ConditionOnAction',
      action: this.actions.assignVendor[0],
      orderBy: 'vendor.firstName',
    },
  ];

  constructor(
    public inspectionService: InspectionService,
    public userService: UserService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit() {
    this.loadDebounced
      .pipe(
        debounceTime(500),
        switchMap(parms => this.loadDataLive(parms)),
      )
      .subscribe();

    this.canAdd = await this.userService.hasPermissions([permissions.INSPECTION.CREATE]);
  }

  loadData(parms) {
    this.loadDebounced.next(parms);
  }

  async loadDataLive(params) {
    let rows: any[];

    [rows, this.count] = await this.inspectionService.waiting({ ...params, ...{ status: InspectionStatus.WAITING } });
    this.loading = false;
    this.inspections = rows.map(i => ({
      ...i,
      date: i.dueDate ? dateAsString(new Date(i.dueDate)) : '',
      daysSince: ((Date.now() - new Date(i.createdAt).getTime()) / 1000 / 60 / 60 / 24).toFixed(),
    }));
    this.cdr.markForCheck();
  }

  assignVendor(ev, inspection: Inspection) {
    console.log('assignVendor', ev, inspection);
    ev.stopPropagation();
    this.assignVendorModal.show({
      inspection,
      confirmed: () => {
        this.toastr.success('Inspection saved!');
      },
    });
  }
}
